import { EVALUATOR_PLAYGROUND_BASELINE_SESSION_PROMPT_ID_METADATA_KEY } from '@/Pages/EvaluatorPlayground/constants';
import { useSessions } from '@/hooks/useSwr';

import { useAlignEvaluatorInfo } from './useAlignEvaluator';
import { usePlaygroundStore } from './usePlaygroundStore';

export const useBaselineAlignmentScore = (): number | undefined => {
  const { rule, isAlignEvaluatorV2 } = useAlignEvaluatorInfo();
  const commitHash = usePlaygroundStore(
    (state) => state.prompts[0]?.hubPrompt?.commitHash
  );
  const fullRef = commitHash
    ? `${
        rule?.evaluators?.[0]?.structured?.['hub_ref'].split(':')[0]
      }:${commitHash.slice(0, 8)}`
    : undefined;
  const baselineSessionSwr = useSessions(
    isAlignEvaluatorV2
      ? {
          limit: 1,
          sort_by: 'start_time',
          sort_by_desc: true,
          metadata: JSON.stringify({
            [EVALUATOR_PLAYGROUND_BASELINE_SESSION_PROMPT_ID_METADATA_KEY]:
              fullRef,
          }),
          include_stats: true,
        }
      : null
  );
  const baselineSession = baselineSessionSwr?.data?.rows?.[0];
  const baselineScore = baselineSession?.feedback_stats?.['alignment']?.avg;
  return baselineScore ?? undefined;
};
